type GtagCommands = {
  config: string
  event: string
}

export function sendGTagEvent(
  name: string,
  type: keyof GtagCommands = "event",
) {
  if (window.gtag) {
    window.gtag(type, name)
  }
}
